import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { clsx } from 'clsx';

import ga, { initGoogleAnalytics, SOLARTRIP_COUNTER } from '@ott/google-analytics';

import { getConfig } from 'src/redux/selectors/commonSelectors';

import componentsMap from 'src/components/componentsMap';

import styles from './LayoutPage.scss';

const LayoutPage = () => {
  const config: any = useSelector(getConfig);
  const {
    page: {
      pageBackground = null,
      fullscreen = false,
      forceLayerDown = false,
      pageLocator = null,
    } = {},
    items: configItems,
  } = config || {};

  useEffect(() => {
    initGA();
  }, []);

  const initGA = () => {
    initGoogleAnalytics({
      counterId: SOLARTRIP_COUNTER || GA_TRACKING_CODE,
    })
      .then(() => {
        ga('send', 'pageview');
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getPageStylesFromMeta = () => {
    if (pageBackground) {
      return {
        backgroundColor: pageBackground,
      };
    }

    return {};
  };

  const getPageLocator = () => {
    if (pageLocator) {
      return pageLocator;
    }

    return null;
  };

  const renderItemsNode = () => {
    if (!configItems) {
      return null;
    }

    return config.items.map((item) => {
      const Comp = componentsMap[item.component];

      if (!Comp) {
        console.error(`There's no key ${item.component} in componentsMap!`);
        return null;
      }

      return <Comp key={item.key} className={styles.block} config={config} {...item.props} />;
    });
  };

  return (
    <div
      id="app"
      key="app"
      className={clsx(styles.root, {
        [styles.rootFullscreen]: fullscreen,
        [styles.rootForceLayerDown]: forceLayerDown,
      })}
      data-locator={getPageLocator()}
      style={getPageStylesFromMeta()}
    >
      <div
        className={clsx(styles.content, {
          [styles.contentFullScreen]: fullscreen,
        })}
        key="PageContentNode"
      >
        {renderItemsNode()}
      </div>
    </div>
  );
};

export default LayoutPage;
